import {
  CUSTOM_OPTION_VALUE,
  NO_PERIOD_OPTION_VALUE,
} from 'common/components/period-selector/constants';
import {formatDate} from 'common/formatters/date-formatter';
import {DateTimeFormat} from 'common/proxies/enum-proxy';

export default (state, action) => {
  const newState = {...state};
  const {payload} = action;

  // remove all old state associated with period filter
  delete newState.period;
  delete newState.start;
  delete newState.end;
  delete newState.tz;
  delete newState.periodField;

  // add updated period filter selections to state
  const {end, selected, start, tz, periodField} = payload;

  if (selected === NO_PERIOD_OPTION_VALUE) {
    return newState;
  }

  if (selected === CUSTOM_OPTION_VALUE) {
    newState.start = formatDate(start, DateTimeFormat.DATE);
    newState.end = formatDate(end, DateTimeFormat.DATE);
  } else {
    newState.period = selected;
  }

  if (tz) {
    newState.tz = tz;
  }

  // filter objects by a model (date/datetime) attribute
  if (periodField) {
    newState.periodField = periodField;
  }

  return newState;
};
